import { onBeforeUnmount, ref, watch, onMounted } from 'vue';
import raf from '../../_util/raf';
const StatusQueue = ['measure', 'align', null, 'motion'];
export default (visible, doMeasure) => {
    const status = ref(null);
    const rafRef = ref();
    const destroyRef = ref(false);
    function setStatus(nextStatus) {
        if (!destroyRef.value) {
            status.value = nextStatus;
        }
    }
    function cancelRaf() {
        raf.cancel(rafRef.value);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.value = raf(() => {
            // Only align should be manually trigger
            let newStatus = status.value;
            switch (status.value) {
                case 'align':
                    newStatus = 'motion';
                    break;
                case 'motion':
                    newStatus = 'stable';
                    break;
                default:
            }
            setStatus(newStatus);
            callback?.();
        });
    }
    watch(visible, () => {
        setStatus('measure');
    }, { immediate: true, flush: 'post' });
    onMounted(() => {
        // Go next status
        watch(status, () => {
            switch (status.value) {
                case 'measure':
                    doMeasure();
                    break;
                default:
            }
            if (status.value) {
                rafRef.value = raf(async () => {
                    const index = StatusQueue.indexOf(status.value);
                    const nextStatus = StatusQueue[index + 1];
                    if (nextStatus && index !== -1) {
                        setStatus(nextStatus);
                    }
                });
            }
        }, { immediate: true, flush: 'post' });
    });
    onBeforeUnmount(() => {
        destroyRef.value = true;
        cancelRaf();
    });
    return [status, goNextStatus];
};
